import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { LOCAL__ui_generation_set_hovered_button_grid2d_dimension } from '@/state/ui/generation/LOCAL__ui_generation_set_hovered_button_grid2d_dimension';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD_PRIMITIVE__base } from '@shared/dto/generation/graph_invoke/_fields/_primitives/_base/FIELD_PRIMITIVE__base';
import { FIELD_PRIMITIVE__bool } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__bool';

interface PROPS {
  field: FIELD_PRIMITIVE__bool;
}

export function G_UI_FIELD_PRIMITIVE__bool_list_item({ field }: PROPS) {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { g_general__ui_disabled, g_hovered_grid2d_column, g_hovered_grid2d_row } = use_slice_ui([
    'g_general__ui_disabled',
    'g_hovered_grid2d_column',
    'g_hovered_grid2d_row',
  ]);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * STATE
   */

  let { graph } = generation_current.tool;

  /*
   * EVENTS
   */

  async function onClick() {
    if (is_disabled()) return;

    let field_from_graph = graph.field__get_primitive(field.meta);

    if (field.get_value() == field_from_graph.get_value()) return;

    await UTILS__graph_data.update_field(graph, field);
  }

  function onMouseEnter() {
    if (field.meta.grid2d__is_column) {
      dispatch(LOCAL__ui_generation_set_hovered_button_grid2d_dimension({ g_hovered_grid2d_column: field, g_hovered_grid2d_dimension_from_grid: false }));
    } else if (field.meta.grid2d__is_row) {
      dispatch(LOCAL__ui_generation_set_hovered_button_grid2d_dimension({ g_hovered_grid2d_row: field, g_hovered_grid2d_dimension_from_grid: false }));
    }
  }

  function onMouseLeave() {
    dispatch(LOCAL__ui_generation_set_hovered_button_grid2d_dimension());
  }

  /*
   * METHODS
   */

  function get_class_name_grid2d_dimension(grid2d_dimension: FIELD__base) {
    if (grid2d_dimension.is_stub()) return '';
    if (!(grid2d_dimension instanceof FIELD_PRIMITIVE__base)) return '';
    if (grid2d_dimension.meta.field_id != field.meta.field_id) return '';
    if (grid2d_dimension.get_value() != field.get_value()) return '';

    return 'g_sidebar_list_item_hovered !border-solid';
  }

  function is_used_in_generation() {
    let field_from_graph = generation_current.tool.graph.field__get_primitive(field.meta);

    return field_from_graph.get_value() == field.get_value();
  }

  function is_disabled() {
    return g_general__ui_disabled || !current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE);
  }

  /*
   * HTML
   */

  return (
    <div
      key={`${field.meta.field_id}_${field.get_value()}`}
      {...{ onClick, onMouseEnter, onMouseLeave }}
      className={`
            g_sidebar_list_item gap-2 pl-4 w-full
            ${is_used_in_generation() && 'g_sidebar_list_item_hovered border-dashed font-bold'}

            ${get_class_name_grid2d_dimension(g_hovered_grid2d_column)}
            ${get_class_name_grid2d_dimension(g_hovered_grid2d_row)}
          `}
    >
      <div className="truncate">{field.get_value() ? 'Yes' : 'No'}</div>
    </div>
  );
}
